module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_9005.c350f523.png";